import { render, staticRenderFns } from "./NominationCommitteeEdit.vue?vue&type=template&id=3118b9fe"
import script from "./NominationCommitteeEdit.vue?vue&type=script&lang=js"
export * from "./NominationCommitteeEdit.vue?vue&type=script&lang=js"
import style0 from "./NominationCommitteeEdit.vue?vue&type=style&index=0&id=3118b9fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports